








































































import Vue from 'vue';
import Component from 'vue-class-component';
import apiClient from '@/app/clients/api-client';
import TButton from '@/lib/form/button/Button.vue';
import TTextarea from '@/lib/form/textarea/Textarea.vue';
import TInput from '@/lib/form/input/Input.vue';

@Component({
  name: 'CreateSpaceModal',
  components: {
    TButton,
    TTextarea,
    TInput
  }
})
export default class CreateSpaceModal extends Vue {
  private space: any = null;
  private name = '';
  private description = '';
  private invalidMsg = '';
  private createLoader = false;

  get isEdit() {
    return !!(this.space && this.space.spaceId);
  }

  beforeOpen(event) {
    this.space = (event && event.params && event.params.space) || null;
    this.name = this.space?.title || '';
    this.description = this.space?.description || '';
    this.invalidMsg = '';
    this.createLoader = false;
  }

  blur() {
    this.invalidMsg = this.name.trim()
      ? ''
      : this.$t('nav.space.input_error') + '';
  }

  save() {
    if (!this.name.trim()) {
      this.blur();
      return;
    }
    this.invalidMsg = '';
    this.createLoader = true;

    const name = this.name.trim();
    const description = this.description.trim();

    (this.isEdit
      ? apiClient.editSpace(this.space.spaceId, name, description)
      : apiClient.createSpace(name, description)
    )
      .then(space => {
        this.$modal.hide('create-space-modal');
        this.$emit(this.isEdit ? 'updated' : 'created', space);
      })
      .catch(e => this.$error(e))
      .finally(() => {
        this.createLoader = false;
      });
  }
}
